/* eslint-disable-next-line no-restricted-imports */
import type { BrandSpecial, Cart as tCart } from '@jane/shared/models';
import type { Cart } from '@jane/shared/types';

export const getBundlesInProgress = ({
  brandSpecials,
  cart,
}: {
  brandSpecials: BrandSpecial[];
  cart?: Cart | tCart;
}): BrandSpecial[] => {
  if (!cart) return [];

  //get brand special ids that have been applied to the cart
  const appliedBrandSpecialIds = cart?.brand_discounts?.map(
    (discount) => discount.brand_special_id
  );

  // get available brand special ids from products
  const productBrandSpecialIds = cart?.products?.map(
    (product) => product.applicable_brand_special_ids
  );

  // flatten and remove duplicates
  const applicableBrandSpecialIds = [
    ...new Set(productBrandSpecialIds?.flatMap((arr) => arr)),
  ];

  // pull out the brand specials that are bundles, available for the products, but not applied to the cart
  const bundlesInProgress =
    brandSpecials?.filter(({ id, special_type }) => {
      return (
        special_type !== 'product' &&
        applicableBrandSpecialIds?.includes(id) &&
        !appliedBrandSpecialIds?.includes(id)
      );
    }) ?? [];

  return bundlesInProgress;
};
